import React from 'react';
import CallSuggestions from '../../components/common/CallSuggestions/CallSuggestions';
import { closeCallSuggestions } from '../../store/actions/callSuggestions';
import { getSuggestions, getSuggestionsTimestamp, isCallSuggestionsOpen } from '../../store/selectors/callSuggestions';
import { getSuggestionCallFrequency } from '../../store/selectors/trainer';
import useLocalization from '../../localization/useLocalization';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import type { RootState } from '../../store/types';

function CallSuggestionsContainer() {
    const dispatch = useAppDispatch();
    const localization = useLocalization();

    const stateProps = useAppSelector((state: RootState) => ({
        suggestionCallFrequency: getSuggestionCallFrequency(state),
        callSuggestionsOpen: isCallSuggestionsOpen(state),
        suggestions: getSuggestions(state),
        suggestionsTimestamp: getSuggestionsTimestamp(state)
    }));

    return <CallSuggestions {...stateProps} localization={localization} closeCallSuggestions={() => dispatch(closeCallSuggestions())} />;
}

export default CallSuggestionsContainer;
